/* Climbing v6: approved interactions, connected to native Shopify controls. */
(function () {
  'use strict';

  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  function init(root) {
    if (!root) return;
    var share = root.querySelector('#shareCopy');
    if (share && !share.dataset.sportReady) {
      share.dataset.sportReady = 'true';
      share.addEventListener('click', function () {
        var label = share.textContent;
        var canonical = document.querySelector('link[rel="canonical"]');
        var url = share.dataset.url || (canonical && canonical.href) || window.location.href;
        function done(ok) {
          share.textContent = ok ? share.dataset.success : share.dataset.failure;
          share.classList.toggle('is-done', ok);
          setTimeout(function () {
            share.textContent = label;
            share.classList.remove('is-done');
          }, 1800);
        }
        function fallback() {
          var field = document.createElement('textarea');
          var previous = document.activeElement;
          try {
            field.value = url;
            field.setAttribute('readonly', '');
            field.style.position = 'fixed';
            field.style.opacity = '0';
            document.body.appendChild(field);
            field.select();
            done(document.execCommand('copy'));
          } catch (error) {
            done(false);
          } finally {
            field.remove();
            if (previous && previous.focus) previous.focus();
          }
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () { done(true); }, fallback);
        } else {
          fallback();
        }
      });
    }

    var pick = root.querySelector('#pick');
    var range = pick && pick.querySelector('#concRange');
    var out = pick && pick.querySelector('#concOut');
    if (range && out && !range.dataset.sportReady) {
      range.dataset.sportReady = 'true';
      var rungs = Array.prototype.slice.call(pick.querySelectorAll('.ladder .rung'));
      var thumb = pick.querySelector('#concThumb');
      var ticks = pick.querySelector('.concTicks');
      var suffix = Array.prototype.filter.call(out.childNodes, function (node) {
        return node.nodeType === Node.TEXT_NODE;
      }).map(function (node) { return node.textContent; }).join('');
      range.max = Math.max(0, rungs.length - 1);
      range.disabled = rungs.length < 2;
      out.setAttribute('aria-live', 'polite');
      if (ticks) {
        ticks.replaceChildren();
        rungs.forEach(function (rung) {
          var tick = document.createElement('span');
          tick.textContent = rung.dataset.concentration + '%';
          ticks.appendChild(tick);
        });
      }
      rungs.forEach(function (rung) {
        var image = rung.querySelector('.rungImg');
        if (image) [image.dataset.sel, image.dataset.x].forEach(function (url) {
          if (url) { var preload = new Image(); preload.src = url; }
        });
      });
      function apply() {
        var index = Math.max(0, Math.min(rungs.length - 1, parseInt(range.value, 10) || 0));
        var selected = rungs[index];
        if (!selected) return;
        var percent = selected.dataset.concentration + '%';
        var name = selected.querySelector('.rname');
        var emoji = selected.querySelector('.fEmoji');
        var strong = document.createElement('b');
        var price = document.createElement('span');
        strong.textContent = percent;
        price.textContent = selected.dataset.price;
        out.replaceChildren(strong, document.createTextNode(suffix), price);
        range.setAttribute('aria-valuetext', percent + ' ' + (name ? name.textContent : '') + ', ' + selected.dataset.price);
        if (thumb) {
          thumb.textContent = emoji ? emoji.textContent : '';
          var fraction = rungs.length > 1 ? index / (rungs.length - 1) : 0;
          thumb.style.insetInlineStart = 'calc(' + fraction * 100 + '% + ' + (24 - fraction * 48) + 'px)';
        }
        rungs.forEach(function (rung, rungIndex) {
          var on = rungIndex === index;
          rung.classList.toggle('win', on);
          var image = rung.querySelector('.rungImg');
          if (image) {
            var next = on ? image.dataset.sel : image.dataset.x;
            if (next && image.getAttribute('src') !== next) image.setAttribute('src', next);
          }
        });
      }
      range.addEventListener('input', apply);
      rungs.forEach(function (rung, index) {
        function select() { range.value = index; apply(); }
        rung.addEventListener('mouseenter', function () { if (finePointer.matches) select(); });
        rung.addEventListener('focus', select);
        rung.addEventListener('shopify:block:select', select);
      });
      apply();
    }

    var ke2 = root.querySelector('#clubsKe2');
    if (ke2 && !ke2.dataset.sportReady) {
      ke2.dataset.sportReady = 'true';
      var live = false;
      var raf = 0;
      var observer;
      function tick() {
        raf = 0;
        if (motion.matches) { ke2.style.transform = 'rotate(-6deg)'; return; }
        var bounds = ke2.getBoundingClientRect();
        var height = window.innerHeight || 1;
        var progress = Math.min(1, Math.max(0, (height - bounds.top) / (height + bounds.height)));
        ke2.style.transform = 'rotate(' + (-22 + progress * 32).toFixed(2) + 'deg)';
      }
      function onScroll() { if (live && !raf && !motion.matches) raf = requestAnimationFrame(tick); }
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { live = entry.isIntersecting; if (live) onScroll(); });
        }, { rootMargin: '20% 0px' });
        observer.observe(ke2);
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        motion.addEventListener('change', tick);
        tick();
      } else {
        ke2.style.transform = 'rotate(-6deg)';
      }
      ke2.sportCleanup = function () {
        if (observer) observer.disconnect();
        cancelAnimationFrame(raf);
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        motion.removeEventListener('change', tick);
      };
    }
  }

  function boot() { init(document.querySelector('#ka-goal')); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function (event) {
    var ke2 = event.target.querySelector('#clubsKe2');
    if (ke2 && ke2.sportCleanup) ke2.sportCleanup();
  });
  document.addEventListener('shopify:block:select', function (event) {
    var detail = event.target.closest('details');
    if (detail) detail.open = true;
  });
})();
